import { Button, Grid, Typography } from "@mui/material";
import { Box, Container, Stack } from "@mui/system";
import React, { useState } from "react";
import {
  ReportMaxDateLimit,
  SettingsMenuList,
  SideBarMenuNames,
} from "../../core/Constants";
import SideBarMenuItems from "../SideBarMenuItems";
import ReportMenuItems from "../ReportMenuItems";
import { connectToStore } from "../../data/store";
import Loader from "../common/Loader";
import MessagePopup from "../common/MessagePopUp";
import Utils from "../../core/Utils";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CountryHelper from "../../core/CountryHelper";
import moment from "moment";
import VisibilityIcon from '@mui/icons-material/Visibility';

const LeadReport = () => {
  document.title = "Leads Report";
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);
  const [localSettings, setLocalSettings] = useState(connectToStore());

  const handleMsgClose = () => {
    setMsgOpen(false);
  };

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      let dateDiff = dateArray[1].diff(dateArray[0], "days");
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText("Please select a valid date range.");
        setMsgOpen(true);
      } else if (dateDiff > ReportMaxDateLimit) {
        setMsgText(
          "Please note that the maximum date range you can select is 366 days. You can choose any start date within the past 366 days, but the end date cannot exceed this limit."
        );
        setMsgOpen(true);
      } else {
        setSelectedDate(dateArray);
      }
    }
  };

  const handleSubmit = () => {
    setIsLoading(true);
    let url = "reports/GetLeadReports?";
    let reportUrl =
      Utils.GetServiceUrl() +
      url +
      "branchId=" +
      localSettings.branch.branchId +
      "&businessId=" +
      localSettings.business.id +
      "&startDate=" +
      Utils.GetISODateTimeString(selectedDate[0]) +
      "&endDate=" +
      Utils.GetISODateTimeString(selectedDate[1]) +
      "&token=" +
      localSettings.token +
      "&culture=" +
      CountryHelper.GetAPICulture(localSettings.country.Culture);
    setIsLoading(false);
    window.open(reportUrl, "_blank");

  };

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.InvoiceReport} />
            <Grid xs={12} className="content-sec c-sec2">
              <Grid container direction="row" className="">
                <ReportMenuItems
                  selectedMenu={SettingsMenuList.BusinessReports.LeadsReport}
                />
                <Grid xs={12} md={9}>
                  <Grid spacing={2} className="form-sec" paddingBottom="100px">
                    <Stack
                      alignSelf="center"
                      justifyContent="end"
                      direction="row"
                      flex="1"
                      className="card white-bg p-1 mb-1"
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        style={{ height: "100%" }}
                      >
                        <DateRangePicker
                          showLeadingZeros={true}
                          onChange={onDateChange}
                          value={selectedDate}
                          locale={CountryHelper.GetDateCulture(
                            localSettings.country.Culture
                          )}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon
                              style={{
                                "font-size": "24px",
                                "align-self": "center",
                                color: "#666666",
                              }}
                            />
                          }
                        />
                      </Stack>
                      <Stack direction="row" justifyContent="end">
                        <Button
                          className="btn btn-secondary"
                          variant="contained"
                          type="submit"
                          onClick={handleSubmit}
                        >
                          <VisibilityIcon /> &nbsp;
                          View / Download Statement
                        </Button>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>

              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default LeadReport;
